/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_No_EndpointInputs */

const en_live_caption_no_endpoint = /** @type {(inputs: Live_Caption_No_EndpointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No endpoint configured`)
};

const fr_live_caption_no_endpoint = /** @type {(inputs: Live_Caption_No_EndpointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun point de terminaison configuré`)
};

const de_live_caption_no_endpoint = /** @type {(inputs: Live_Caption_No_EndpointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Endpunkt konfiguriert`)
};

const it_live_caption_no_endpoint = /** @type {(inputs: Live_Caption_No_EndpointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun endpoint configurato`)
};

const ru_live_caption_no_endpoint = /** @type {(inputs: Live_Caption_No_EndpointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Конечная точка не настроена`)
};

const es_live_caption_no_endpoint = /** @type {(inputs: Live_Caption_No_EndpointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se ha configurado ningún punto final.`)
};

const zh_cn2_live_caption_no_endpoint = /** @type {(inputs: Live_Caption_No_EndpointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未配置端点`)
};

const ja_live_caption_no_endpoint = /** @type {(inputs: Live_Caption_No_EndpointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エンドポイントが設定されていません`)
};

const hi_live_caption_no_endpoint = /** @type {(inputs: Live_Caption_No_EndpointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई एंडपॉइंट कॉन्फ़िगर नहीं किया गया है`)
};

const pt_pt2_live_caption_no_endpoint = /** @type {(inputs: Live_Caption_No_EndpointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum ponto de extremidade configurado`)
};

/**
* | output |
* | --- |
* | "No endpoint configured" |
*
* @param {Live_Caption_No_EndpointInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_no_endpoint = /** @type {((inputs?: Live_Caption_No_EndpointInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_No_EndpointInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_no_endpoint(inputs)
	if (locale === "de") return de_live_caption_no_endpoint(inputs)
	if (locale === "it") return it_live_caption_no_endpoint(inputs)
	if (locale === "ru") return ru_live_caption_no_endpoint(inputs)
	if (locale === "es") return es_live_caption_no_endpoint(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_no_endpoint(inputs)
	if (locale === "ja") return ja_live_caption_no_endpoint(inputs)
	if (locale === "hi") return hi_live_caption_no_endpoint(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_no_endpoint(inputs)
	return en_live_caption_no_endpoint(inputs)
});